import {
  fetchStrapiCollection,
  getStrapiMediaUrl,
  hasStrapiConfig,
} from "./client";
import {
  faqs as fallbackFaqs,
  frequentlyasked as fallbackFaqDownloads,
  downloads as fallbackDownloads,
  courtfees as fallbackCourtFees,
  events as fallbackEvents,
  teaminfo as fallbackTeamMembers,
} from "../../components/resources/data/data";

function sortByOrder(items) {
  return [...items].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
}

function mapFaq(item) {
  return {
    id: item.id,
    question: item.question || "",
    answer: item.answer || "",
    url: item.linkUrl || item.url || "",
    sortOrder: item.sortOrder || 0,
  };
}

function mapDownload(item) {
  return {
    id: item.id,
    image: getStrapiMediaUrl(item.thumbnail),
    heading: item.title || item.heading || "",
    date: item.date || "",
    download: getStrapiMediaUrl(item.file),
    category: item.category || "",
    sortOrder: item.sortOrder || 0,
  };
}

function mapEvent(item) {
  return {
    id: item.id,
    image: getStrapiMediaUrl(item.image),
    title: item.title || "",
    description: item.summary || item.description || "",
    content: item.content || "",
    sortOrder: item.sortOrder || 0,
  };
}

function mapTeamMember(item) {
  return {
    id: item.id,
    image: getStrapiMediaUrl(item.image),
    position: item.position || "",
    name: item.name || "",
    description: item.bio || item.description || "",
    department: item.department || "",
    sortOrder: item.sortOrder || 0,
  };
}

function mapGalleryItem(item) {
  return {
    id: item.id,
    image: getStrapiMediaUrl(item.image),
    sortOrder: item.sortOrder || 0,
  };
}

async function withFallback(fetcher, fallbackData) {
  if (!hasStrapiConfig()) {
    return fallbackData;
  }

  try {
    const data = await fetcher();
    return data && data.length > 0 ? data : fallbackData;
  } catch (error) {
    console.error("Falling back to local content because Strapi is unavailable.", error);
    return fallbackData;
  }
}

export function getFaqs() {
  return withFallback(
    async () => sortByOrder((await fetchStrapiCollection("/api/faqs")).map(mapFaq)),
    fallbackFaqs
  );
}

export function getFaqDownloads() {
  return withFallback(
    async () =>
      sortByOrder(
        (
          await fetchStrapiCollection(
            "/api/downloads?filters[category][$eq]=faq&populate[file]=true&populate[thumbnail]=true"
          )
        )
          .map(mapDownload)
      ),
    fallbackFaqDownloads
  );
}

export function getDownloads() {
  return withFallback(
    async () =>
      sortByOrder(
        (
          await fetchStrapiCollection(
            "/api/downloads?populate[file]=true&populate[thumbnail]=true"
          )
        ).map(mapDownload)
      ),
    fallbackDownloads
  );
}

export function getCourtFees() {
  return withFallback(
    async () =>
      sortByOrder(
        (
          await fetchStrapiCollection(
            "/api/fee-documents?populate[file]=true&populate[thumbnail]=true"
          )
        ).map(mapDownload)
      ),
    fallbackCourtFees
  );
}

export function getEvents() {
  return withFallback(
    async () =>
      sortByOrder(
        (await fetchStrapiCollection("/api/events?populate[image]=true")).map(mapEvent)
      ),
    fallbackEvents
  );
}

export function getTeamMembers() {
  return withFallback(
    async () =>
      sortByOrder(
        (await fetchStrapiCollection("/api/team-members?populate[image]=true")).map(
          mapTeamMember
        )
      ),
    fallbackTeamMembers
  );
}

export function getGalleryItems(fallbackData = []) {
  return withFallback(
    async () =>
      sortByOrder(
        (await fetchStrapiCollection("/api/gallery-items?populate[image]=true&pagination[pageSize]=500")).map(
          mapGalleryItem
        )
      ),
    fallbackData
  );
}
